export default __webpack_public_path__ + "static/media/woman-having-pain-injured-back-healthcare-back-pain-concept (1).688075ed.jpg";